import { maxLength } from './length'

export const UUID_ATENDIMENTO_PROFISSIONAL_MAX_LENGTH = 96

export function maxLengthUuidAtendimentoProfissional(value: string) {
  return maxLength(UUID_ATENDIMENTO_PROFISSIONAL_MAX_LENGTH)(value)
}
